<template>
  <div class="app-adj-info">
    <!-- License Info -->
    <div class="app-adj-info" v-if="!isBusinessUser && adjudicationLicenseInfo">
      <div class="app-adj-info-row" v-if="adjudicationLicenseInfo.adjudicationLicenseInformation">
        <div class="app-adj-info-group">
          <div class="app-adj-flex">
            <div class="app-adj-info-child-group">
              <label for="privilegeType">License Privilege</label>
            </div>
            <div class="app-adj-info-child-group">
              <div class="statusTextFlex">
                <img
                  v-if="adjudicationLicenseInfo.adjudicationLicenseInformation.privilegeStatus === 'Suspended'"
                  class="active-icon"
                  src="static/status-not-active.png"
                  alt="Icon"
                />
                <img
                  v-else
                  class="active-icon"
                  src="static/status-active.png"
                  alt="Icon"
                />
                <span for="statusText">{{ adjudicationLicenseInfo.adjudicationLicenseInformation.privilegeStatus }}</span>
              </div>
            </div>
            <div
              class="app-adj-info-child-group"
              v-if="!adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails && adjudicationLicenseInfo.adjudicationLicenseInformation.suspensions.length > 0"
            >
              <button
                class="showMoreText"
                type="button"
                @click="isSubTabActive(adjudicationLicenseInfo.adjudicationLicenseInformation)"
                @keydown.enter="isSubTabActive(adjudicationLicenseInfo.adjudicationLicenseInformation)"
              >
                {{ adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails ? 'Less' : 'Details' }}
              </button>
            </div>
          </div>
          <!-- Details Header -->
          <div
            class="app-adj-flex"
            v-if="adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails && adjudicationLicenseInfo.adjudicationLicenseInformation.suspensions.length > 0"
          >
            <div class="app-adj-info-child-desc-group">
              <label for="suspensionDescription">Suspension Description</label>
            </div>
            <div class="app-adj-info-child-grid-group">
              <label for="suspensionEffectiveDate">Suspension Effective Date</label>
            </div>
            <div class="app-adj-info-child-grid-group">
              <label for="suspensionStatus">Suspension Status</label>
            </div>
          </div>
          <!-- Details List -->
          <div
            class="app-adj-info-group"
            v-if="adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails"
          >
            <div
              class="app-adj-info-row"
              v-for="(suspensionInfo, i) in adjudicationLicenseInfo.adjudicationLicenseInformation.suspensions"
              :key="i"
            >
              <div class="app-adj-flex">
                <div class="app-adj-info-child-desc-group">
                  <span for="suspensionDescriptionText">{{ suspensionInfo.suspensionDescription }}</span>
                </div>
                <div class="app-adj-info-child-grid-group-text">
                  <span for="suspensionEffectiveDateText">{{ suspensionInfo.suspensionEffectiveDate }}</span>
                </div>
                <div class="app-adj-info-child-grid-group-text">
                  <span for="suspensionStatusText">{{ suspensionInfo.suspensionStatus }}</span>
                </div>
              </div>
            </div>

          </div>
          <!-- "Less" button -->
          <div class="app-adj-flex">
            <div class="app-adj-info-child-group" v-if="adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails">
              <button
                class="showMoreText"
                type="button"
                @click="isSubTabActive(adjudicationLicenseInfo.adjudicationLicenseInformation)"
                @keydown.enter="isSubTabActive(adjudicationLicenseInfo.adjudicationLicenseInformation)"
              >
                {{ adjudicationLicenseInfo.adjudicationLicenseInformation.showDetails ? 'Less' : 'Details' }}
              </button>
            </div>
          </div>
          <div class="app-adj-info-group-link susp-link" v-if="hasActive04">
            <a href="https://www.ri.gov/DMV/license_reinstatement/" target="_blank" rel="noopener noreferrer">License Reinstatement Failure to Pay/Appear </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Commercial License Info -->
    <div class="app-adj-info" v-if="!isBusinessUser && adjudicationCommercialLicenseInfo">
      <div class="app-adj-info-row" v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation">
        <div class="app-adj-info-group">
          <div class="app-adj-flex">
            <div class="app-adj-info-child-group">
              <label for="privilegeType">Commercial License Privilege</label>
            </div>
            <div class="app-adj-info-child-group">
              <span>
                <div class="statusTextFlex">
                  <img
                    v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.privilegeStatus === 'Suspended'"
                    class="active-icon"
                    src="static/status-not-active.png"
                    alt="Icon"
                  />
                  <img
                    v-else
                    class="active-icon"
                    src="static/status-active.png"
                    alt="Icon"
                  />
                  <span for="statusText">{{ adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.privilegeStatus }}</span>
                </div>
              </span>
            </div>
            <div
              class="app-adj-info-child-group"
              v-if="!adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails && adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.suspensions.length > 0"
            >
              <button
                class="showMoreText"
                type="button"
                @click="isSubTabActive(adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation)"
                @keydown.enter="isSubTabActive(adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation)"
              >
                {{ adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails ? 'Less' : 'Details' }}
              </button>
            </div>
          </div>
          <!-- Details Header -->
          <div
            class="app-adj-flex"
            v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails && adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.suspensions.length > 0"
          >
            <div class="app-adj-info-child-desc-group">
              <label for="suspensionDescription">Suspension Description</label>
            </div>
            <div class="app-adj-info-child-grid-group">
              <label for="suspensionEffectiveDate">Suspension Effective Date</label>
            </div>
            <div class="app-adj-info-child-grid-group">
              <label for="suspensionStatus">Suspension Status</label>
            </div>
          </div>
          <!-- Details List -->
          <div
            class="app-adj-info-group"
            v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails"
          >
            <div
              class="app-adj-info-row"
              v-for="(suspensionInfo, i) in adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.suspensions"
              :key="i"
            >
              <div class="app-adj-flex">
                <div class="app-adj-info-child-desc-group">
                  <span for="suspensionDescriptionText">{{ suspensionInfo.suspensionDescription }}</span>
                </div>
                <div class="app-adj-info-child-grid-group-text">
                  <span for="suspensionEffectiveDateText">{{ suspensionInfo.suspensionEffectiveDate }}</span>
                </div>
                <div class="app-adj-info-child-grid-group-text">
                  <span for="suspensionStatusText">{{ suspensionInfo.suspensionStatus }}</span>
                </div>
              </div>
            </div>
          </div>
        <div class="app-adj-flex">
            <div class="app-adj-info-child-group" v-if="adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails">
              <button 
                class="showMoreText" 
                type="button" 
                @click="isSubTabActive(adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation)" 
                @keydown.enter="isSubTabActive(adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation)"
              >
                {{adjudicationCommercialLicenseInfo.adjudicationCommercialLicenseInformation.showDetails ? 'Less':'Details' }}
              </button>
            </div>  
        </div>
        </div>
      </div>
    </div>
    <!-- Registration Info -->
    <div class="app-adj-info" v-if="adjudicationRegistrationInfo"> 
      <div class="app-adj-info-row" v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation">
        <div class="app-adj-info-group">
            <div class="app-adj-flex">
                <div class="app-adj-info-child-group">
                    <label for="privilegeType">Registration Privilege</label>                
                </div>
                <div class="app-adj-info-child-group">                
                    <div class="statusTextFlex">
                        <img v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation.privilegeStatus == 'Suspended'" class="active-icon" src="static/status-not-active.png" alt="Icon">
                        <img v-else class="active-icon" src="static/status-active.png" alt="Icon">
                        <span for="statusText">{{ adjudicationRegistrationInfo.adjudicationRegistrationInformation.privilegeStatus }}</span>  
                    </div>               
                </div>
                <div class="app-adj-info-child-group" v-if="!adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails && adjudicationRegistrationInfo.adjudicationRegistrationInformation.suspensions.length > 0">
                  <button 
                    class="showMoreText" 
                    type="button" 
                    @click="isSubTabActive(adjudicationRegistrationInfo.adjudicationRegistrationInformation)"
                    @keydown.enter="isSubTabActive(adjudicationRegistrationInfo.adjudicationRegistrationInformation)"
                  > 
                    {{adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails ? 'Less':'Details' }}
                  </button>
                </div>  
            </div>
            <div class="app-adj-flex" v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails && adjudicationRegistrationInfo.adjudicationRegistrationInformation.suspensions.length > 0" >
                <div class="app-adj-info-child-desc-group">    
                    <label for="suspensionDescription">Suspension Description</label>                
                </div>
                <div class="app-adj-info-child-grid-group">
                    <label for="suspensionEffectiveDate">Suspension Effective Date</label>    
                </div>
                <div class="app-adj-info-child-grid-group">
                    <label for="suspensionStatus">Suspension Status</label> 
                </div>
            </div>  
            <div class="app-adj-info-group"  v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails">
              <div class="app-adj-info-row" v-for="(suspensionInfo, i) in adjudicationRegistrationInfo.adjudicationRegistrationInformation.suspensions" :key="i">
                <div class="app-adj-flex">
                    <div class="app-adj-info-child-desc-group">    
                        <span for="suspensionDescriptionText">{{suspensionInfo.suspensionDescription}}</span>
                    </div>
                    <div class="app-adj-info-child-grid-group-text">
                        <span for="suspensionEffectiveDateText">{{suspensionInfo.suspensionEffectiveDate}}</span>
                    </div>
                    <div class="app-adj-info-child-grid-group-text">
                        <span for="suspensionStatusText">{{suspensionInfo.suspensionStatus}}</span>
                    </div>
                </div> 
              </div>
            </div>
            <div class="app-adj-flex">
              <div class="app-adj-info-child-group" v-if="adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails">
                <button 
                  class="showMoreText" 
                  type="button"
                  @click="isSubTabActive(adjudicationRegistrationInfo.adjudicationRegistrationInformation)"
                  @keydown.enter="isSubTabActive(adjudicationRegistrationInfo.adjudicationRegistrationInformation)"
                >
                  {{adjudicationRegistrationInfo.adjudicationRegistrationInformation.showDetails ? 'Less':'Details' }}
                </button>
              </div>  
            </div>
            <div class="app-adj-info-group-link" v-if="hasActiveC4">
              <a href="https://www.ri.gov/app/dmv/reinstatement/" target="_blank" rel="noopener noreferrer">Insurance Revocation Reinstatement</a>
            </div>
        </div>
      </div>
    </div>
    <div v-if="showSystemAlert">
      <SystemAlert/>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import SystemAlert from '@/components/SystemAlert';
import * as COMMONS from '../../store/_commons';

const store = useStore();

// Computed properties 
const isBusinessUser = computed(() => store.state.guestLogin.isBusinessUser);

const adjudicationLicenseInfo = computed(() => store.getters[COMMONS.GUEST_ADJUDICATION_LICENSE_INFO]);
const adjudicationCommercialLicenseInfo = computed(() => store.getters[COMMONS.GUEST_ADJUDICATION_COMMERCIAL_LICENSE_INFO]);
const adjudicationRegistrationInfo = computed(() => {
  if (isBusinessUser.value) {
    const businessData = store.getters[COMMONS.GUEST_BUSINESS_ADJUDICATION_REGISTRATION_INFO];
    return {
      adjudicationRegistrationInformation: businessData.businessAdjudicationRegistrationInformation
    };
  }
  return store.getters[COMMONS.GUEST_ADJUDICATION_REGISTRATION_INFO];
});

const hasActive04 = computed(() => {
  if (isBusinessUser.value || !adjudicationLicenseInfo.value?.adjudicationLicenseInformation?.suspensions) {
    return false;
  }
  const suspensions = adjudicationLicenseInfo.value.adjudicationLicenseInformation.suspensions;
  return suspensions.some(
    susp => susp.suspensionCode === '04' && susp.suspensionStatus === 'Active'
  );
});

const hasActiveC4 = computed(() => {
    if (!adjudicationRegistrationInfo.value?.adjudicationRegistrationInformation?.suspensions) {
    return false;
  }
  const suspensions = adjudicationRegistrationInfo.value.adjudicationRegistrationInformation.suspensions;
  return suspensions.some(
    susp => susp.suspensionCode === 'C4' && susp.suspensionStatus === 'Active'
  );
});

// Computed property for SystemAlert
const showSystemAlert = computed(() => {
  if (isBusinessUser.value) {
    return !adjudicationRegistrationInfo.value?.adjudicationRegistrationInformation;
  }
  return (
    !adjudicationLicenseInfo.value?.adjudicationLicenseInformation &&
    !adjudicationCommercialLicenseInfo.value?.adjudicationCommercialLicenseInformation &&
    !adjudicationRegistrationInfo.value?.adjudicationRegistrationInformation
  );
});

// Methods 
const isSubTabActive = (item) => {
  item.showDetails = !item.showDetails;
};
</script>


<style scoped lang="scss">
  .app-adj-info-row {
    margin: 5px 0px 10px 0px;
    border-bottom: 1px solid #F2F2F2;
    span, label {
        font-size: 1rem;
    }
    .app-adj-flex {
        display: flex;
        gap: 0rem 2rem; 
        .app-adj-info-child-group {
            width: 265px;
            padding: 1rem;
            .app-icon {
                margin-right: 5px;
                filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
                vertical-align: text-bottom;
            }
            .statusText {
                margin: 2px;
                vertical-align: text-bottom;
            }
            .statusTextFlex {
                display: flex;
                vertical-align: text-bottom;
                margin-top: 5px;
            }
        }
        .app-adj-info-child-grid-group {
            width: 265px;
            .app-icon {
                margin-right: 5px;
                filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
                vertical-align: text-bottom;
            }
            .statusText {
                margin: 2px;
                vertical-align: text-bottom;
            }
            .statusTextFlex {
                display: flex;
                vertical-align: text-bottom;
                margin-top: 5px;
                font-size: large;
            }
        }
        .app-adj-info-child-desc-group {
            width: 365px;
            padding-left: 1rem;
            .app-icon {
                margin-right: 5px;
                filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
                vertical-align: text-bottom;
            }
            .statusText {
                margin: 2px;
                vertical-align: text-bottom;
            }
            .statusTextFlex {
                display: flex;
                vertical-align: text-bottom;
                margin-top: 5px;
            }
        }

        .app-adj-info-child-grid-group-text {
            width: 265px;
            .app-icon {
                margin-right: 5px;
                filter: invert(0%) sepia(0%) saturate(7500%) hue-rotate(143deg) brightness(108%) contrast(106%);
                vertical-align: text-top;
            }
            .statusText {
                margin: 2px;
                vertical-align: text-bottom;
            }
            .statusTextFlex {
                display: flex;
                vertical-align: text-bottom;
                margin-top: 5px;
            }
        }
    }
    .app-adj-info-group-link{
      display: flex;
      justify-content: center;
      padding: 15px;
    }
  }
  .active-icon {
    width: 25px;
    height: 25px;
    vertical-align: middle;
    padding-right:5px; 
    padding-bottom:5px;
  }
  .subTabCaret {
    text-align: right;
    position: absolute;
    right: 10%;
  }
  .subtab-icon {
    height: 25px;
    width: 25px;
  }
  .showMoreText {
    cursor: pointer;
  }

  .app-adj-info-row:nth-child(odd) {
    background-color: #F2F2F2;
  }

  @media only screen and (max-width: 600px) {
    .app-adj-info-row .app-adj-flex .app-adj-info-child-group {
      min-width: 155px;
    }
    .app-adj-info-child-group {
      span {
        word-wrap: break-word;
      }
    }
    .subTabCaret {
      width: 120px;
      position: static;
    }
    .app-adj-flex  {
      flex-wrap: wrap;
    }

    .app-adj-info-child-desc-group {
      width: 240px !important;
      padding-left: 0rem;
    }
    .app-adj-info-child-grid-group-text {
      padding-left: 1rem;
      width: 165px;
    }

    .app-adj-info-child-grid-group {
      padding-left: 1rem;
    }
  }
  @media only screen and (min-width: 600px) and (max-width: 1135px) {
    .app-adj-info-row .app-adj-flex .app-adj-info-child-group {
      width: 225px;
    }
    .subTabCaret {
      position: static;
    }
    .app-adj-flex  {
      flex-wrap: wrap;
    }
    .app-adj-info-child-desc-group {
      width: 240px !important;
      padding-left: 0rem;
    }
    .app-adj-info-child-grid-group-text {
      padding-left: 1rem;
      width: 165px;
    }

    .app-adj-info-child-grid-group {
      padding-left: 1rem;
    }
  }
</style>